import { Tab, Nav, Row, Col } from 'react-bootstrap';
import React from 'react';
import SimpleDataTables from '../../Common/SimpleDataTables';

const CommonTabs = ({columns, trackings}) => {
    console.log('trackings', trackings);

    return (
        <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey={trackings[0].trackingId}>
                <Row>
                    <Col sm={3}>
                        <Nav variant="pills" className="flex-column">
                            {trackings && trackings.map(tracking => (
                                <Nav.Item key={tracking.trackingId}>
                                    <Nav.Link eventKey={tracking.trackingId}>Tracking: {tracking.trackingId}</Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                    </Col>
                    <Col sm={9}>
                        <Tab.Content>
                            {trackings && trackings.map(tracking => (
                                <Tab.Pane key={tracking.trackingId} eventKey={tracking.trackingId}>
                                    <SimpleDataTables columns={columns} rows={tracking.products} />
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    );
};

export default CommonTabs;